
<template>
  <div class="box" v-loading="loading">
    <p class="login_title">{{$t('m.login')}}/{{$t('m.reg')}}</p>
    <p class="login_title_sm">{{$t('m.sms_login')}}</p>
    <div class="login_info">
      <div class="form_item">
        <p>{{$t('m.phone')}}</p>
        <div class="form_inputbox">
          <div class="seledArea" @click.stop="showCountryFun">
            <img class="flag_icon" :src="selCountry.logo">
            <span class="fc-pad-lr-min">+{{selCountry.countryNum}}</span>
            <img class="select_icon" :src="(showCountry && $store.state.isShowSelArea)?require('../../assets/img/icon_up.png'):require('../../assets/img/icon_down.png')">
          </div>
          <input class="login_input" type="text" v-model.trim="mobile" oninput="value=value.replace(/\D/g,'')" minlength="6" :placeholder="$t('m.user_enter_bind_phone')" />
          <div class="selarea_box" v-if="showCountry && $store.state.isShowSelArea">
            <sel-area @countryOption="countryOptionFun"/>
          </div>
        </div>
      </div>
      <div class="form_item">
        <p>{{$t('m.vericode')}}</p>
        <div class="form_inputbox">
          <input class="login_input smscode_input" type="text" v-model.trim="code" oninput="value=value.replace(/\D/g,'')" maxlength="6" :placeholder="$t('m.input_vericode')" />
          <div class="getcode">
            <send-code :areaCode="selCountry.countryNum" :mobile="mobile" :scene="0"></send-code>
          </div>
        </div>
      </div>
      <div class="fc-flex-center">
        <div class="login_btn" @click="goLogin">{{$t('m.login')}}/{{$t('m.reg')}}</div>
      </div>
      <p class="fc-text-center fc-color-gray-light fc-mar-t-min fc-pointer changetxt" @click="changephone">{{$t('m.change_mobile')}}?</p>
    </div>
  </div>
</template>
<script>

import { mobeilLogin } from '../../api/login/login';
import { getCountryMsg } from '../../api/common';
import { isMobileValid,isSmscode } from '../../utils/coding-utils';
import sendcode from "../../components/sendcode";
import SelArea from '../../components/SelArea';
export default {
  components: {
    "send-code": sendcode,
    "sel-area":SelArea,
  },
  //mixins: [countDown],
  props:{
    agreeXieyi: {
      type: Boolean,
      default () {
        return false;
      }
    },
  },
  data() {
    return {
      mobile: "",
      code: "",
      loading:false,
      showCountry:false,
      countryArr:[],
      selCountry:{},
    };
  },
  mounted() {
    this.getCountryMsgFun();
  },
  methods: {
    // 显示区号？
    showCountryFun(){
      if(this.showCountry && this.$store.state.isShowSelArea){
        this.showCountry = false;
        this.$store.state.isShowSelArea = false;
      }else{
        this.$store.state.isShowSelArea=true;
        this.showCountry = true;
      }
    },
    //获取默认区号
    getCountryMsgFun(){
      getCountryMsg().then(({data}) =>{
        this.selCountry=data.result;
      })
    },
    countryOptionFun(val){
      this.selCountry = val;
      console.log(val);
      this.showCountry = false;
    },
    changephone(){
        this.$emit("changephone",2)
    },
    
    goLogin(){
      if(!this.agreeXieyi){
        this.$message.error(this.$t('m.agree_agreement'));
        return false;
      }
      if (!isMobileValid(this.mobile)) {
        this.$message.error(this.$t('m.check_phone_istrue'));
        return false;
      }
      if(!isSmscode(this.code)){
        this.$message.error(this.$t('m.vericode_error'));
        return false;
      }
      this.loading=true;
      mobeilLogin({
        mobile:this.mobile,
        code:this.code,
        areaCode:this.selCountry.countryNum,
        lang:this.$i18n.locale
      })
      .then(({data}) => {
        console.log(data);
        this.loading=false;
        this.$store.commit('setUser', data.data);
       if(data.data.status===3){
          //已入驻
          this.$router.push({
            path: '/guild/my-guild-detail'
          });
        }else{
          //0未申请入驻 1入驻申请未通过
          this.$router.push({
            name: 'apply-index',
            params:{
              userStatus:data.data.status,
              stepActive:data.data.status==0?0:2
            }
          });
        }
      }).catch(error => {
        this.loading=false;
        //this.$message.error('登录失败,稍后重试');
       
      });
    },
       
  },
};
</script>
<style lang="less" scoped>
.sendcode_box{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  .login_input{
    flex: 1;
  }
}

input::-ms-input-placeholder {
	font-size: .18rem;
	color: #999;
}
input::-webkit-input-placeholder {
	font-size: .18rem;
	color: #999;
}
.box{font-size: .14rem;}
input {
  outline: none;
}
.box {
  width: 80%;
  max-width: 400px;
  margin: 0 auto;
}
.login {
  &_title {
    font-size: .36rem;
    text-align: center;
    padding:.67rem 0 .48rem;
    &_sm {
      font-size: .3rem;
      margin-bottom: .4rem;
    }
  }
  &_info {
    .form_item {
      margin-top: .32rem;
      position: relative;
      p{
        font-size: .18rem;
      }
    }
    .login_input {
      width: 100%;
      height: .54rem;
      font-size: .18rem;
      line-height: .3rem;
      border: none;
      padding: .1rem 0;
      box-sizing: border-box;
      background-color: transparent;
      color: #333;
    }
    .getcode{
        color: #008AFF;
        font-size: .18rem;
    }
  }
  &_btn{
    min-width: 1.8rem;
    max-width: 3rem;
    min-height: .28rem; 
    padding: .1rem;
    font-size: .18rem;
    color: #fff;
    text-align: center;
    background-color: #008AFF;
    border-radius: .4rem;
    margin: .48rem auto 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

  }
}
.form_inputbox{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  position: relative;
  span{
    font-size: .18rem;
    // color: #888;
  }
  input{
    flex: 1;
    // padding-left: 1em !important;
    border:none !important;
  }
}
@media only screen and (max-width: 767px) {
  .login_title{
    padding: .38rem 0 .48rem;
    font-size: .4rem;
    &_sm{
      font-size: .32rem;
      margin-bottom: 0;
    }
  }
  .login_info {
    margin-bottom: .4rem;
    .login_input{
      border-color: #e4e4e4;
    }
    .form_item{
      margin-top:.32rem;
    }
  }
  .login_btn{
    min-width: 3.2rem;
    max-width: 5rem;
  }
  .login_btn,.login_info .form_item p,.login_info .login_input,.changetxt{
      font-size: .26rem !important;
  }
  .form_inputbox{
    border-color: #e4e4e4;
    span{
      font-size: .26rem;
    }
  }
}

@media only screen and (max-width: 540px) {
  input::-ms-input-placeholder {
    font-size: .24rem;
  }
  input::-webkit-input-placeholder {
    font-size: .24rem;
  }
  .login_input {
    font-size: .24rem !important;
  }
  .getcode{
    font-size: .24rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/sms.vue